/**
 * controller for article recommend list content
 * @requires Vue, jQuery, moment.js
 */
var articleRecommendControl = new Vue({
    el: '#articleRecommendContent',
    data: {
        dataApi: {
            url: Link.prefix.realmName + 'portal/article/getRand',
            method: 'get'
        },
        limit : 4,
        status: '',
        dataList: [],
        columnMapping : {
            'like' : 'praise',
            'comment_count': 'commentCount',
            'published_time': 'createTime'
        }
    },
    methods: {
        init: function () {
            this.loadArticleList(1);
        },
        loadArticleList: function (page) {
            var me = this;
            me.page = page;

            if (me.pageCount != 0 && page > me.pageCount) {
                addConsole('[info] no more page.');
                return;
            }

            me.status = 'loading';
            $.ajax(me.dataApi.url, {
                type: me.dataApi.method,
                data : {
                    'limit' : me.limit
                },
                success: function (result) {
                    if (result.errorCode) {
                        dialog.msg(result.msg);
                        return;
                    }

                    var dataList = result.data;

                    if(dataList==null){
                        dialog.msg("您还未发表任何文章噢")
                    }

                    // for (var i=0; i<dataList.length; i++)
                    // {
                    //  me.dataList.push(dataColumnConvert(dataList[i], {
                    //      'comment_count' : 'commentCount',
                    //      'published_time' : 'createTime'
                    //  }));
                    // }

                    dataList = listDataColumnConvert(dataList, me.columnMapping);

                    // for (var i = 0; i < dataList.length; i++) {
                    //     dataList[i].imageList = filterImageUrlList(dataList[i].content);
                    //     if (dataList[i].imageList.length > 3) {
                    //         dataList[i].imageList = dataList[i].imageList.slice(0, 3);
                    //     }
                    // }

                    me.status = 'success';
                    me.dataList = me.dataList.concat(dataList);

                    me.pageCount = result.data.totalPage;
                    me.total = result.data.totalCount;
                },
                error: function () {
                    me.status = 'error';
                    setTimeout(function () {
                        me.loadArticleList(me.page);
                    }, 3000);
                },
                complete : function (){
                    me.status = 'ready';
                }
            });
        },
        formatPublishedDate: function (timestamp) {
            return moment(timestamp).format('YYYY-mm-dd');
        },
        formatTimeFromNow: function (timestamp) {
            return moment(timestamp).fromNow();
        },
        viewDetail: function (event) {
            var target = event.target;
            var item = target.parentNode;

            var id = $(item).attr('data-item-id');
            if (!id) {
                dialog.msg('出错了');
                return;
            }

            location.href = 'detail.html?id=' + id;
        }
    }
});
articleRecommendControl.init();




/** WEBPACK FOOTER **
 ** D:/app project/shixun-web/src/shixun-mobile/js/article/articleRecommendControl.js
 **/